  
  function changeImage(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
  
    var allImages = document.querySelectorAll('[data-alt-color]');
    allImages.forEach(function(image) {
      image.classList.add('thumb-hidden-pdp');
    });
  
    var imagesToShow = document.querySelectorAll(`[alt*="${productColor}"]`);
    imagesToShow.forEach(function(image) {
      image.classList.remove('thumb-hidden-pdp');
    });
  };
  
  
  function changeImagePLP(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);

    if( image ) {
      if ( image.alt === productColor ) {
          image.classList.remove('thumb-hidden');
          if(image_two){
            if( image_two.id === productId ){
                image_two.classList.add('thumb-hidden');
             
            }
          }
      }
    }
  };


  function outImage(clickedSwatch) {
    var productColor = clickedSwatch.getAttribute('data-option-value');
    var productId = clickedSwatch.getAttribute('data-product-id');
    var image = document.querySelector(`[data-thumbnail-color="${productColor}"]`);
    var image_two = document.querySelector(`[data-mi-atributo="${productId}"]`);


    if( image ) {
      if ( image.alt === productColor ) {
          image.classList.add('thumb-hidden');
          if(image_two){
            if( image_two.id === productId ){
                image_two.classList.remove('thumb-hidden');
             
            }
          }
      }
    }
  };